import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data";
import { Reveal } from "./primitives";

// asymmetric spans for the tetris grid (lg:grid-cols-6)
const SPAN = [
  "lg:col-span-3", "lg:col-span-3",
  "lg:col-span-2", "lg:col-span-2", "lg:col-span-2",
  "lg:col-span-3", "lg:col-span-3",
  "lg:col-span-4", "lg:col-span-2",
];

const Card = ({ s, spanClass }) => (
  <Reveal className={`col-span-1 ${spanClass}`}>
    <div
      data-testid={`service-card-${s.n}`}
      className="group relative h-72 md:h-80 overflow-hidden bg-brand-asphalt border border-brand-concrete clip-corner"
    >
      <img
        src={s.img}
        alt={s.title}
        className="absolute inset-0 w-full h-full object-cover opacity-45 grayscale group-hover:grayscale-0 group-hover:opacity-70 group-hover:scale-105 transition-all duration-700 ease-out"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-brand-black via-brand-black/50 to-transparent" />
      <span
        aria-hidden="true"
        className="absolute -right-3 -bottom-7 font-anton text-[8.5rem] leading-none text-white/[0.05] group-hover:text-brand-red/15 transition-colors duration-700 select-none pointer-events-none"
      >
        {s.n}
      </span>
      <span className="absolute left-0 top-0 h-1 w-0 bg-brand-red group-hover:w-full transition-all duration-500" />

      <div className="relative z-10 h-full flex flex-col justify-between p-6">
        <span className="font-mono-p text-sm text-brand-red">{s.n}</span>
        <div>
          <div className="flex items-center justify-between">
            <h3 className="font-anton uppercase text-2xl md:text-3xl tracking-tight">{s.title}</h3>
            <ArrowUpRight className="w-6 h-6 text-brand-red opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-400" />
          </div>
          <p className="mt-3 font-ibm text-sm text-white/60 max-w-sm leading-relaxed">{s.desc}</p>
        </div>
      </div>
    </div>
  </Reveal>
);

export const Services = () => (
  <section id="services" data-testid="services" className="relative py-24 md:py-36 px-6 md:px-12 lg:px-16 bg-brand-black">
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14 md:mb-20">
      <Reveal>
        <span className="font-mono-p text-xs uppercase tracking-[0.28em] text-brand-red">What We Do</span>
        <h2 className="mt-4 font-anton uppercase text-5xl md:text-7xl tracking-tight leading-[0.9]">
          Full-Scope<br />Site Work.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="max-w-sm font-ibm text-white/60 leading-relaxed">
          One crew, one number, every stage of the ground. Nine core services that take a lot
          from untouched to build-ready.
        </p>
      </Reveal>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-5 md:gap-6">
      {SERVICES.map((s, i) => (
        <Card key={s.n} s={s} spanClass={SPAN[i]} />
      ))}
    </div>
  </section>
);
